<template>
		<!-- Google maps Vue component. Displays a map and a list of map markers. -->
		<GmapMap
			ref="gmap"
			:center="initialPos"
			:zoom="zoomLevel"
			@zoom_changed="zoomChanged"
			@bounds_changed="throttledBoundsChanged"
			:style="computedStyle"
			:options="{ streetViewControl: false, fullscreenControl: false, mapTypeControl: false }">
			<template v-if="markers.length">
				<GmapCluster :gridSize="40" :maxZoom="11" :clusterSize="20" :zoomOnClick="true">
					<GmapMarker
						v-for="marker in markers"
						:key="marker.id"
						:position="marker.location"
						:clickable="marker.clickable"
						:icon="getMarkerIcon(marker)"
						:title="marker.title ? marker.title : ''"
						@mouseover="hoveredMarker = marker"
						@mouseout="hoveredMarker = null"
						@click="clickMarker(marker)"
					/>
				</GmapCluster>
			</template>
		</GmapMap>
</template>
<script>
import { convertToCdnUrl } from 'utils';
import throttle from 'lodash/throttle';

export default {
	props: {
		/**
		 * Map markers.
		 */
		markers: {
			type: Array,
			default: () => [],
		},
		// Initial position, somewhere in sweden.
		initialPos: {
			type: Object,
			default: () => { return { lat: 58, lng: 17 }; },
		},
		// Initial zoom level.
		zoomLevel: {
			type: Number,
			default: 5,
		},
		height: {
			type: String,
			default: '370px',
		},
		width: {
			type: String,
			default: '100%',
		},
	},
	data () {
		return {
			// Reference to map.
			mapInstance: null,
			// Bounding box of area viewed in the map.
			boundingBox: null,
			hoveredMarker: null,
		};
	},
	computed: {
		computedStyle () {
			return {
				width: this.width,
				height: this.height,
			};
		},
		defaultMarkerIcon () {
			return convertToCdnUrl('/img/icons/location.svg');
		},
	},
	methods: {
		initMap () {
			this.$refs.gmap.$mapPromise.then(map => {
				this.mapInstance = map;
				console.log('Set up map instance');
				this.$emit('map-loaded');
			});
		},
		zoomChanged(data) {
			// @TODO Emit some event here.
		},
		throttledBoundsChanged (box) {
			this.boundsChanged(box);
		},
		boundsChanged: throttle(function (box) {
			if (box) {
				this.boundingBox =  {
					north: box.ka.g,
					east: box.oa.g,
					south: box.ka.h,
					west: box.oa.h,
				};
				this.$emit('bounds-changed', this.boundingBox);
			}
		}, 300),
		getMarkerIcon (marker) {
			if (marker === this.hoveredMarker && marker.hoverIcon) {
				return convertToCdnUrl(marker.hoverIcon);
			}

			if ( marker.icon) {
				return convertToCdnUrl(marker.icon);
			}

			return this.defaultMarkerIcon;
		},
		setZoomLevel (zoom) {
			if (this.mapInstance) {
				this.mapInstance.setZoom(zoom);
			}
		},
		/**
		 * Pans the map to a location and sets the default zoom level.
		 */
		panAndZoom (location, zoom = 13) {
			this.panTo(location);
			// Default zoom level when panning.
			this.setZoomLevel(zoom);
		},
		/**
		 * Pans the map to a location.
		 */
		panTo (location) {
			if (this.mapInstance) {
				this.mapInstance.panTo(location);
			}
		},
		/**
		 * Pans and zooms the map to fit (view) a bounding box.
		 */
		fitBounds (bounds) {
			if (this.mapInstance) {
				// Safety padding to make sure that the map does not get zoomed out too much when fitting.
				const padding = { bottom: -10, left: -10, right: -10, top: -10 };
				this.mapInstance.fitBounds(bounds, padding);
			}
		},
		/**
		 * Called when a store is clicked on the map.
		 */
		clickMarker (marker) {
			this.$emit('marker-clicked', marker);
		},
	},
	mounted () {
		this.initMap();
	},
};
</script>